module.exports = __webpack_public_path__ + "media/Q3.96d78197.mp4";